 window.onload = function() {
    var elements = document.querySelectorAll(".yotpo-subscription-benefits-wrapper");
      for (var i = 0; i < elements.length; i++) {
            elements[i].classList.add("active");
        }
      }
$("body").on("click", ".yotpo-selling-plan-radio-label", function() {
  if ($(this).hasClass('yotpo-checked')) {
      $(".yotpo-subscription-benefits-wrapper").addClass("active");
  } else {
   $(".yotpo-subscription-benefits-wrapper").removeClass("active");
  }
});



 

